import useSwr from "@/core/composables/swr/useSwr";
import {computed} from "vue";
import {cacheKey} from "@/lib/cache";
import {apodisCoinApi} from "@/container";
import {PaginationRequest} from "@/core/interfaces/api";

const useApodisCoinTransactions = (params: PaginationRequest) => {
    const key = computed(() => {
        return cacheKey("apodis-coins/transactions", params);
    });

    return useSwr(
        key,
        () => apodisCoinApi().transactions(params),
    );
};

export default useApodisCoinTransactions;
